'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _actions = require('./actions');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    tutorialOn: state.site.tutorialOn,
    tutorial: state.site.tutorial
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleTutorial: function toggleTutorial() {
      return dispatch((0, _actions.toggleTutorial)());
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Tutorial/selectors.js
// module id = 438
// module chunks = 0